import { render, staticRenderFns } from "./signup-page.vue?vue&type=template&id=55824428&scoped=true"
import script from "./signup-page.vue?vue&type=script&lang=js"
export * from "./signup-page.vue?vue&type=script&lang=js"
import style0 from "./signup-page.vue?vue&type=style&index=0&id=55824428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55824428",
  null
  
)

export default component.exports